import { createAsyncThunk } from "@reduxjs/toolkit";
import type { RootState, AppDispatch } from "../store";
import type { CapacityMeta, SeriesEntry, CapacityDay } from "./capacitiesSlice";

export const preloadSpaceSeries = createAsyncThunk<
  { entry: SeriesEntry },
  CapacityMeta,
  { state: RootState; dispatch: AppDispatch }
>("capacities/preload", async (meta, _thunkApi) => {
  const params = new URLSearchParams({
    spaceId: String(meta.spaceId),
    start: meta.start,
    end: meta.end,
  });
  if (meta.sizeId != null && !isNaN(meta.sizeId)) params.set("animalSizeId", String(meta.sizeId));
  if (meta.excludeBookingId != null && !isNaN(meta.excludeBookingId))
    params.set("excludeBookingId", String(meta.excludeBookingId));

  const res = await fetch(`/api/bookings/spacecapacity?${params.toString()}`);
  if (!res.ok) throw new Error(`preload failed ${res.status}`);
  const data = await res.json();
  const startDate = new Date(meta.start);
  startDate.setHours(0, 0, 0, 0);
  const endDate = new Date(meta.end);
  endDate.setHours(0, 0, 0, 0);
  const daysCount = Math.max(0, Math.floor((endDate.getTime() - startDate.getTime()) / (24 * 3600 * 1000)));
  const normDays: CapacityDay[] = Array.from({ length: daysCount }, (_, i) => {
    const d = new Date(startDate);
    d.setDate(startDate.getDate() + i);
    return { date: d.toISOString(), am: 0, pm: 0, overall: 0 } as CapacityDay;
  });
  const src = Array.isArray(data?.days) ? data.days : [];
  for (let i = 0; i < Math.min(src.length, normDays.length); i++) {
    const sd = src[i] as any;
    const am = Math.max(0, Number(sd?.am ?? 0) || 0);
    const pm = Math.max(0, Number(sd?.pm ?? 0) || 0);
    normDays[i] = { date: normDays[i].date, am, pm, overall: Math.max(am, pm) } as CapacityDay;
  }
  const entry: SeriesEntry = {
    meta,
    maxOverall: Math.max(0, Number(data?.maxOverall ?? 0) || 0),
    days: normDays,
    status: "ready",
    updatedAt: Date.now(),
  };
  return { entry };
});
